<template lang="pug">
  div
    v-bottom-sheet(v-model="productSheet" max-width="600px" scrollable)
      v-card.pt-4(flat)
        v-card-text.pa-0(style="color: rgba(0, 0, 0, 1);")

          v-form(ref="form")
            div.px-4(style="overflow-x: hidden;")

              v-row(no-gutters)
                v-col
                  .s1 {{ product.name }} x{{ quantity }}
                v-col.shrink(style="min-width:87px" align="right")
                  .s2 {{ product.price * quantity | displayPrice }}
                  .p2.primary400--text(v-if="productDiscount") - {{ productDiscount | displayPrice }}

              .description.mt-6(v-if="product.description")
                .p2.primary400--text {{ product.description }}
                div.show-description.d-flex.mt-6
                  y-checkbox.my-auto.mx-0.pa-0(v-model="showDescription" hide-details)
                    template(v-slot:label)
                      div.p1.my-auto Show description in invoice
              
              v-row
                v-divider.basic300.my-5

              v-layout
                v-spacer
                .mb-1.label.basic600--text.text-uppercase Select quantity
                v-spacer
              v-layout
                v-spacer
                v-btn.my-auto(icon small @click="quantity--" :disabled="quantity < 1")
                  eva-icon.mt-1(name="minus-circle-outline" height="24" width="24" :fill="quantity < 1 ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
                v-layout.divbox.subtitle-1.my-auto.text-center.mx-1(style="width: 100%") 
                  .s1.ma-auto {{ quantity }}
                v-btn.my-auto(icon small @click="quantity++" :disabled="product.inventory_enabled && product.inventory_qty <= quantity")
                  eva-icon.mt-1(name="plus-circle-outline" height="24" width="24" :fill="product.inventory_enabled && product.inventory_qty <= quantity ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
                v-spacer

              v-layout.my-6(v-if="hasDiscountPermission")
                v-spacer
                .discount(v-if="discount")
                  v-layout
                    .s2.primary400--text(v-if="discount.isPercentage") Discount: {{ discount.value }}%
                    .s2.primary400--text(v-else) Discount: {{ discount.value | displayPrice }}
                    eva-icon.mt-1.ml-2(name="trash-outline" height="16" width="16" :fill="$vuetify.theme.themes[$theme].danger500" @click="discount = null")
                .button-Aa-medium.info500--text(v-else @click="openEditDiscount = true") Add discount
                v-spacer
                      
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='productSheet = !productSheet')
            .button-Aa-medium.primary400--text Cancel
          v-btn.mr-2(color='info500' depressed @click="clickSave()")
            .button-AA-medium.basic100--text {{ $t('save') }}

    .discount(style="max-width:500px")
      AddDiscount(v-if="openEditDiscount" :open.sync="openEditDiscount" :initialDiscount.sync="discount" @added="handleAddDiscount")

</template>

<script>
import AddDiscount from '@/components/forms/AddDiscount.vue'

import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Product',
  components: { AddDiscount },
  props: {
    language: {
      type: String,
      default: 'en'
    },
    open: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: null
    },
    selectedProduct: {
      type: Object,
      default: null
    },
    hasDiscountPermission: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    quantity: 0,
    showDescription: false,
    openEditDiscount: false,
    discount: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    productSheet: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    item () {
      return {
        quantity: this.quantity,
        product: this.product,
        discount: this.discount ? this.discount.value : 0
        ,
        show_discount_as_percentage: this.discount ? this.discount.isPercentage : false
      }
    },
    productDiscount () {
      if (!this.discount) {
        return 0
      }
      let discountAmount = this.discount.value
      if (this.discount.isPercentage) {
        discountAmount = this.discount.value * this.product.price / this.$currency.multiplier
      }
      return parseInt(discountAmount) * this.quantity
    }
  },
  mounted () {
    if (this.product.description_visibility.includes('invoice')) {
      this.showDescription = true
    }
    if (this.selectedProduct) {
      this.quantity = this.selectedProduct.quantity
      if (this.selectedProduct.discount) {
        this.discount = { 
          value: this.selectedProduct.discount || 0,
          isPercentage: this.selectedProduct.show_discount_as_percentage || false
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleAddDiscount (val) {
      this.discount = val
    },
    clickSave () {
      this.$emit('updateItem', this.item)
      this.productSheet = false
      const params = {}
      if (this.showDescription) {
        params.description_visibility = ["invoice"]
      } else {
        params.description_visibility = []
      }
      this.axios.patch(`/products/${this.product.id}/`, params)
        .then(resp => {
          this.product.description_visibility = resp.data.description_visibility
          this.$emit('updateItem', this.item)
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.divbox {
  border: 2px solid var(--v-basic400);
  background-color: var(--v-basic200);
  height: 40px;
  max-width: 60px;
  border-radius: 5px;
}
</style>

<i18n>
{
  "en": {
    "select": "select",
    "save": "save",
    "back": "back"
  },
  "id": {
    "select": "pilih",
    "save": "simpan",
    "back": "kembali"
  },
  "ms": {
    "select": "pilih",
    "save": "simpan",
    "back": "kembali"
  },
  "zh": {
    "select": "select",
    "save": "save",
    "back": "back"
  },
  "ta": {
    "select": "select",
    "save": "save",
    "back": "back"
  }
}
</i18n>
